import { render, staticRenderFns } from "./ShareCollectComponent.vue?vue&type=template&id=8defacb0&scoped=true"
import script from "./ShareCollectComponent.vue?vue&type=script&lang=js"
export * from "./ShareCollectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8defacb0",
  null
  
)

export default component.exports